<!-- Register Admin -->
<section>
    <div class="container content-box">

        <!-- Form -->
        <form name="form" class="" (submit)="f.form.valid && onSubmit()" #f="ngForm" novalidate>
            <h1 class="text-center">Create Admin Account</h1>

            <!-- Input Fields -->
            <div class="col-md-12">

                <!-- Email -->
                <div class="row mt-2">
                    <div class="col-md-12">
                        <label class="required-field">Login Email</label>
                        <input type="email" id="email" class="form-control mb-2" placeholder="email" [(ngModel)]="model.email" name="email" #email="ngModel" [ngClass]="{ 'is-invalid': f.submitted && email.invalid }" minlength="6" disabled>
                    </div>
                </div>

                <!-- Agency -->
                <div class="row mt-2">
                    <div class="col-md-12">
                        <label class="required-field">Agency Name</label>
                        <input type="agencyName" id="agencyName" class="form-control mb-2" placeholder="agencyName" [(ngModel)]="model.agencyName" name="agencyName" #agencyName="ngModel" [ngClass]="{ 'is-invalid': f.submitted && agencyName.invalid }" minlength="6" disabled>
                    </div>
                </div>

                <!-- Type -->
                <div class="row mt-2">
                    <div class="col-md-12">
                        <label class="required-field">Admin Type</label>
                        <input type="type" id="type" class="form-control mb-2" placeholder="type" [(ngModel)]="model.type" name="type" #type="ngModel" [ngClass]="{ 'is-invalid': f.submitted && type.invalid }" disabled>
                    </div>
                </div>

                <!-- First Name -->
                <div class="row mt-2">
                    <div class="col-md-12">
                        <label class="required-field">First Name</label>
                        <input type="firstName" id="firstName" class="form-control mb-2" placeholder="First Name" [(ngModel)]="model.firstName" name="firstName" #firstName="ngModel" [ngClass]="{ 'is-invalid': f.submitted && firstName.invalid }" required>
                    </div>
                </div>

                <!-- Last Name -->
                <div class="row mt-2">
                    <div class="col-md-12">
                        <label class="required-field">Last Name</label>
                        <input type="lastName" id="lastName" class="form-control mb-2" placeholder="Last Name" [(ngModel)]="model.lastName" name="lastName" #lastName="ngModel" [ngClass]="{ 'is-invalid': f.submitted && lastName.invalid }" required>
                    </div>
                </div>

                <!-- Password -->
                <div class="row mt-2">
                    <div class="col-md-12">
                        <label class="required-field">Password</label>
                        <input type="password" id="password" class="form-control mb-2" placeholder="Password" [(ngModel)]="model.password" name="password" #password="ngModel" [ngClass]="{ 'is-invalid': f.submitted && password.invalid }" password required minlength="6">

                        <!-- Invalid Password -->
                        <div *ngIf="f.submitted && password.invalid" class="invalid-feedback">
                            <div class="mb-1 text-center" *ngIf="password.errors!.required">Password is required</div>
                            <div class="mb-1 text-center" *ngIf="password.errors!.minlength">Password must be at least 6 characters</div>
                        </div>
                    </div>
                </div>

                <!-- Confirm Password -->
                <div class="row mt-2">
                    <div class="col-md-12">
                        <label class="required-field">Confirm Password</label>
                        <input type="password" id="confirmPassword" class="form-control mb-2" placeholder="Repeat Password" [(ngModel)]="model.confirmPassword" name="confirmPassword" #confirmPassword="ngModel" [ngClass]="{ 'is-invalid': f.submitted && confirmPassword.invalid }"
                            password required validateEqual="password" minlength="6">

                        <!-- Invalid Confirm Password -->
                        <div *ngIf="f.submitted && confirmPassword.invalid" class="invalid-feedback">
                            <div class="mb-1 text-center" [hidden]="confirmPassword.valid || (confirmPassword.pristine && !f.submitted)">Password and Confirm Password need to match</div>
                            <div class="mb-1 text-center" *ngIf="confirmPassword.errors!.minlength">Confirm Password must be at least 6 characters</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Submit -->
            <div class="text-center">
                <button type="submit" class="my-4 btn">Submit</button>
            </div>
        </form>
    </div>
</section>
